import { render, staticRenderFns } from "./newAddKey.vue?vue&type=template&id=4edfee02&scoped=true"
import script from "./newAddKey.vue?vue&type=script&lang=js"
export * from "./newAddKey.vue?vue&type=script&lang=js"
import style0 from "./newAddKey.vue?vue&type=style&index=0&id=4edfee02&prod&scoped=true&lang=less"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4edfee02",
  null
  
)

export default component.exports